/**
 * TSA Section 1 duration 40 from start_set_paper is TARA-module copy
 * (`'tsa' in pid` shared the TARA/BMAT 40-minute branch). Spec §12.4:
 * treat 40 as corrupt. Oxford fallbacks: Section 1 = 90, Section 2 = 30.
 * Other payload durations still win.
 */
export function resolveTsaSectionDurationMinutes(apiDuration, { section } = {}) {
  const fallback = Number(section) === 2 ? 30 : 90;
  const mins = Number(apiDuration);
  if (Number.isFinite(mins) && mins > 0 && mins !== 40) return mins;
  return fallback;
}

export function getTsaEndReviewCopy(phase) {
  const onS2 = String(phase || '').startsWith('p2');
  const section = onS2 ? 'Section 2' : 'Section 1';
  return `You will not be able to return to ${section}. Are you sure you want to continue?`;
}
